import { buffers, channel, SagaIterator } from 'redux-saga';
import { call, take } from 'typed-redux-saga';

export function createQueueSaga<Args extends unknown[], SagaResult>(
    saga: (...args: Args) => SagaIterator<SagaResult>
): [() => SagaIterator<void>, (...args: Args) => SagaIterator<SagaResult>] {
    type QueueEntry = {
        args: Args;
        resolve: (res: SagaResult) => void;
        reject: (error: unknown) => void;
    };

    // Канал очереди, содержит объекты с arg/resolve/reject
    const chan = channel<QueueEntry>(buffers.expanding());

    // watcher, всегда один, запускается один раз
    function* watcher(): SagaIterator<void> {
        while (true) {
            const entry = yield* take(chan);
            try {
                const result = yield* call(saga, ...entry.args);
                entry.resolve(result as SagaResult);
            } catch (error) {
                entry.reject(error);
            }
        }
    }
    function* enqueueSaga(...args: Args): SagaIterator<SagaResult> {
        // Используем промис чтобы получить результат асинхронно
        return yield* call(() => {
            return new Promise<SagaResult>((resolve, reject) => {
                // Пихаем объект в очередь через канал
                chan.put({
                    args,
                    resolve,
                    reject,
                });
            });
        });
    }

    return [watcher, enqueueSaga];
}
